import {
    FETCH_COMMENTS,
    FETCH_COMMENTS_SUCCESS,
    FETCH_COMMENTS_FAILED,
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue } from "firebase/database";

export const fetchComments = (userRatingId) => (dispatch) => {
    const {
        userRatingsRef
    } = firebase;

    dispatch({ type: FETCH_COMMENTS, });
    onValue(userRatingsRef(userRatingId), snapshot => {
        if (snapshot.val()) {
            let rootEntry = snapshot.val();
            let allComments = [];
            for (let key in rootEntry) {
                allComments.push(rootEntry[key])
            }
            dispatch({
                type: FETCH_COMMENTS_SUCCESS,
                payload: allComments,
            });
        } else {
            dispatch({ type: FETCH_COMMENTS_FAILED, });
        }
    })
};